<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title"><a id="pv"></a><a id="pvi"></a><a id="p1">Prologue</a></h1><a id="p1">
<p class="noindent"><em>It had been the third world war or the fourth, depending on who did the counting, but nobody was counting anymore. It was simply “the war”: March 16, 2085, when a third of the world’s population had died in less than a day.</em></p>
<p class="indent"><em>Most of the survivors had no idea why the war had been fought. A breakdown of antiquated systems. A series of misunderstandings. A run of bad luck that culminated in one side’s systems being under the total control of a man who had lost his mind.</em></p>
<p class="indent"><em>The automatic defenses worked quite well; fewer than one in twenty warheads found their marks. So there were still many billions of people left to wonder what to do next, as the radioactive ash settled down, as the biological agents silently spread. There were some who suspected that the worst was yet to come, and they were right.</em></p>
<p class="indent"><em>It was very nearly the end of the world, but it wasn’t the end of civilization. There were still the Worlds, what was left of them: a collection of more-or-less large Earth satellites, a quarter of a million people who didn’t have to worry about fallout or biological warfare. Most of the Worlds had been destroyed during the war, but the largest one had survived, and that’s where most of the people lived: New New York.</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?1853ef84